(() => {
  if (window.__faCityPriorityBootstrapped) return;
  window.__faCityPriorityBootstrapped = true;

  const normalize = (value = '') => String(value).trim().toLowerCase().replace(/\s+/g, ' ');

  function cityName(option) {
    return option?.dataset?.cityName || String(option?.textContent || '').split(' - ')[0];
  }

  function prioritizeKualaLumpur(select) {
    if (!select) return;

    const options = Array.from(select.options || []);
    const kualaLumpur = options.find((option) => normalize(cityName(option)) === 'kuala lumpur');
    if (!kualaLumpur) return;

    const placeholder = options.find((option) => option.value === '');
    const desiredIndex = placeholder ? options.indexOf(placeholder) + 1 : 0;
    if (select.options[desiredIndex] === kualaLumpur) return;

    if (placeholder) placeholder.insertAdjacentElement('afterend', kualaLumpur);
    else select.prepend(kualaLumpur);
  }

  function bind(select) {
    if (!select || select.dataset.faCityPriority === 'true') {
      prioritizeKualaLumpur(select);
      return;
    }

    select.dataset.faCityPriority = 'true';
    prioritizeKualaLumpur(select);

    new MutationObserver(() => prioritizeKualaLumpur(select)).observe(select, {
      childList: true
    });
  }

  function init(root = document) {
    root.querySelectorAll?.('[data-fa-city]').forEach(bind);
    if (root.matches?.('[data-fa-city]')) bind(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
